module.exports = require("buffer");


/*****************
 ** WEBPACK FOOTER
 ** external "buffer"
 ** module id = 333
 ** module chunks = 0
 **/